export interface FillHeightMetrics {
  readonly containerBottom: number;
  readonly elementTop: number;
  readonly contentBelow: number;
  readonly minHeight: number;
}

export const computeFillHeight = ({
  containerBottom,
  elementTop,
  contentBelow,
  minHeight,
}: FillHeightMetrics): number =>
  Math.max(minHeight, Math.floor(containerBottom - elementTop - contentBelow));

const isScrollable = (el: Element): boolean => /(auto|scroll)/.test(getComputedStyle(el).overflowY);

export const findScrollContainer = (el: HTMLElement): HTMLElement => {
  for (let node = el.parentElement; node; node = node.parentElement) {
    if (isScrollable(node)) return node;
  }
  return (document.scrollingElement as HTMLElement | null) ?? document.documentElement;
};

export const findOutermostBlock = (el: HTMLElement, container: HTMLElement): HTMLElement => {
  let outermost = el;
  for (let node = el.parentElement; node && node !== container; node = node.parentElement) {
    if (!['inline', 'contents'].includes(getComputedStyle(node).display)) outermost = node;
  }
  return outermost;
};

export const measureContentBelow = (el: HTMLElement, container: HTMLElement): number => {
  const outermost = findOutermostBlock(el, container);
  const outer = getComputedStyle(outermost);
  const below =
    outermost.getBoundingClientRect().bottom -
    el.getBoundingClientRect().bottom +
    (outermost === el ? 0 : Number.parseFloat(outer.marginBottom) || 0);
  return below + (Number.parseFloat(getComputedStyle(container).paddingBottom) || 0);
};
